import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { AuthProvider } from "./contexts/AuthContext";
import { ContentProvider } from "./contexts/ContentContext";
import { SaleProvider } from "./contexts/SaleContext";
import { BrandsProvider } from "./contexts/BrandsContext";
import { ShippingProvider } from "./contexts/ShippingContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./Pages/Home";
import About from "./Pages/About";
import FAQ from "./Pages/FAQ";
import Products from "./Pages/Products";
import ProductDetailedView from "./Pages/ProductDetailedView";
import CheckoutPage from "./Pages/CheckoutPage";
import OrderSuccessPage from "./Pages/OrderSuccessPage";
import Contact from "./Pages/Contact";
import Categories from "./Pages/Categories";
import ResponsibilitiesPage from "./Pages/ResponsibilitiesPage";
import Login from "./Pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
// Admin panel
import Dashboard from "./AdminPanel/Dashboard";
// Cart
import Cart from "./components/Cart";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
    });
  }, []);

  return (
    <AuthProvider>
      <ContentProvider>
        <SaleProvider>
          <BrandsProvider>
            <ShippingProvider>
              <div className="App">
                <ToastContainer position="top-right" autoClose={4000} newestOnTop pauseOnHover theme="colored" />
                <ScrollToTop />
                <Routes>
                  <Route path="/" element={<div className="website-layout"><Cart /><Home /></div>} />
                  <Route path="/about" element={<div className="website-layout"><Cart /><About /></div>} />
                  <Route path="/products" element={<div className="website-layout"><Cart /><Products /></div>} />
                  <Route path="/product/:id" element={<div className="website-layout"><Cart /><ProductDetailedView /></div>} />
                  <Route path="/checkout" element={<div className="website-layout"><Cart /><CheckoutPage /></div>} />
                  <Route path="/order-success" element={<div className="website-layout"><Cart /><OrderSuccessPage /></div>} />
                  <Route path="/responsibilities" element={<div className="website-layout"><Cart /><ResponsibilitiesPage /></div>} />
                  <Route path="/categories" element={<div className="website-layout"><Cart /><Categories /></div>} />
                  <Route path="/contact" element={<div className="website-layout"><Cart /><Contact /></div>} />
                  <Route path="/login" element={<div className="website-layout"><Cart /><Login /></div>} />
                  <Route path="/faq" element={<div className="website-layout"><Cart /><FAQ /></div>} />
                  {/* Protected Admin Route */}
                  <Route path="/admin/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                </Routes>

              </div>
            </ShippingProvider>
          </BrandsProvider>
        </SaleProvider>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;